import COMMON_ENV from '@/config/env'

function setCookie(name, value, day) {
  // 写cookies
  if (!value) {
    return null
  }
  try {
    const Days = day || 30
    const exp = new Date()
    let val = value
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
    if (typeof val !== 'string') {
      val = JSON.stringify(value)
    }
    if (!day) {
      document.cookie = `${name}=${escape(val)};`
    } else {
      document.cookie = `${name}=${escape(val)};expires=${exp.toGMTString()}`
    }
  } catch (e) {
    return null
  }
  return true
}

function getCookie(name) {
  // 读cookie
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`)
  const arr = document.cookie.match(reg)
  if (arr) {
    return unescape(arr[2])
  }
  return null
}

function delCookie(name) {
  // 删除cookie
  const exp = new Date()
  exp.setTime(exp.getTime() - 1)
  const cval = getCookie(name)
  if (cval != null) {
    document.cookie = `${name}=${cval};expires=${exp.toGMTString()}`
  }
}

// 获取url中的参数
function getUrlParam(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
  let query = window.location.href.split('?')[1] || ''
  const r = query.match(reg)
  if (r != null) {
    return decodeURI(r[2])
  }
  return null
}

// 将url中code=xxx 替换成空字符串
function replaceCode(fullPath) {
  /*eslint-disable*/
  const reg = /code\=\w*(&|$)/
  let href = window.location.href
  let host = href.split('#')[0]

  // ie9  不支持history模式 hash模式
  let hashUrl = fullPath || window.location.hash.replace('#', '')
  let hashArr = hashUrl.split('?')
  let path = encodeURIComponent(hashArr[0].substring(1, hashArr[0].length)) // path
  // 把参数截取成数组[a=1,b=2]
  // let queryList = hashArr[1]?hashArr[1].split('&'):[];
  let query = hashArr[1] ? `&${hashArr[1]}` : ''
  // 取消 #号  拼接成 ?path=path

  href = `${host}?${COMMON_ENV.COMMON_REPLACE_URL}=${path}${query}`

  href = href.replace(reg, '')
  if (href.substr(href.length - 1, 1) === '?' || href.substr(href.length - 1, 1) === '&') {
    // 如果最后一个字符是？
    href = href.substring(0, href.length - 1)
  }
  /* eslint-enable */
  return href
}

function getTokenFn() {
  return getCookie(COMMON_ENV.COMMON_TOKEN)
  // return window.sessionStorage.getItem(COMMON_TOKEN);
}

function setTokenFn(token) {
  if (token) {
    // window.sessionStorage.setItem(COMMON_TOKEN, token);
    setCookie(COMMON_ENV.COMMON_TOKEN, token, COMMON_ENV.COMMON_TOKEN_DAY)
    // window.localStorage.setItem(COMMON_TOKEN,token);
  } else {
    delCookie(COMMON_ENV.COMMON_TOKEN)
    // window.localStorage.removeItem(COMMON_TOKEN);
    // 清除本地缓存信息
    // window.sessionStorage.removeItem(COMMON_TOKEN);
  }
}
// 补0
function add0(m) {
  return m < 10 ? `0${m}` : m
}
// 时间戳转换
function format(shijianchuo) {
  // shijianchuo是整数，否则要parseInt转换
  let time = new Date(shijianchuo)
  let y = time.getFullYear()
  let m = time.getMonth() + 1
  let d = time.getDate()
  let h = time.getHours()
  let mm = time.getMinutes()
  let s = time.getSeconds()
  return `${y}-${add0(m)}-${add0(d)} ${add0(h)}:${add0(mm)}:${add0(s)}`
}

// eslint-disable-next-line object-curly-newline
export { setCookie, getCookie, delCookie, getUrlParam, replaceCode, getTokenFn, setTokenFn, format }
